<div class="sign-in-wrap d-flex justify-content-center mt-4">
  <div class="sign-in-section d-flex flex-column justify-content-center">
    <a href="/home" class="d-block d-flex justify-content-center">
      <img
        src="../../assets/svg/accent_logo_color.svg"
        alt="accent logo"
        class="mb-3"
      />
    </a>
    <h1 class="text-center">Sign in to SautiDB</h1>
    <div class="form-wrapper" [formGroup]="application">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>email</mat-label>
        <input matInput formControlName="email" type="email" formControlName="email"/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>password</mat-label>
        <input matInput formControlName="password" type="password" formControlName="password"/>
      </mat-form-field>
      <button class="form-btn btn m-0" (click)="onSubmitForm()">Sign In</button>
    </div>
  </div>
</div>
